import validate from '../../../services/reduxValidate.js'

export default function(data) {
  const constraints = {
    // Status
    'freelance.work_permit': { presence: { allowEmpty: false } },
    'freelance.situation': { presence: { allowEmpty: false } },
    // Availability
    'freelance.date_available': { isoDate: true, presence: { allowEmpty: false } },
    // Location and mobility
    'freelance.relocation_long_fulltime': { inclusion: { within: [true, false] } },
  }

  const errors = {
    freelance: {},
    user: {},
  }

  // City
  let city = data.user.city
  if (Array.isArray(city)) {
    city = city[0]
  }

  if (!city || city.label === "" || !city.id) {
    errors.user.city = 'La ville est invalide'
  }

  const validation = validate(data, constraints)

  return {
    freelance: {...errors.freelance, ...(validation ? validation.freelance : {}) },
    user: {...errors.user, ...(validation ? validation.user : {}) },
  }
}

export const validatePrice = (price) => {
  return validate({price}, {
    price: {
      presence: {
        allowEmpty: false,
        message:'Veuillez renseigner un TJM',
      },
      numericality: {
        onlyInteger: true,
        strict: true,
        greaterThan: 0,
        lessThan: 50000,
        notGreaterThan: 'Votre TJM mission minimum doit être supérieur a 0€',
        notLessThan: 'Votre TJM mission minimum doit être inférieur à 50 000€',
      }
    }
  })
}

export const validateYearlyBrut = (yearlyBrut) => {
  return validate({yearlyBrut}, {
    yearlyBrut: {
      presence: {
        allowEmpty: false,
        message: 'Veuillez renseigner un montant annuel brut',
      },
      numericality: {
        onlyInteger: true,
        strict: true,
        greaterThan: 0,
        lessThan: 500000,
        notGreaterThan: 'Votre montant annuel brut doit être supérieur a 0€',
        notLessThan: 'Votre montant annuel brut doit être inférieur à 500 000€'
      }
    }
  })
}
